import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		OjId: [],
		VyrobekndOzn: [],
	},
	filter: {
		OjId: 0 as number | null,
		VyrobekndOzn: null as string | null,
		NeodeslanePrp: true as boolean | null,
		RychlaObjednavkaPrp: true as boolean | null,
		SkladovaObjednavkaPrp: true as boolean | null,

	},
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
